import { render, staticRenderFns } from "./studentPlaneAlreadyApply.vue?vue&type=template&id=0d2beb7a&scoped=true"
import script from "./studentPlaneAlreadyApply.vue?vue&type=script&lang=js"
export * from "./studentPlaneAlreadyApply.vue?vue&type=script&lang=js"
import style0 from "./studentPlaneAlreadyApply.vue?vue&type=style&index=0&id=0d2beb7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2beb7a",
  null
  
)

export default component.exports